import React from 'react';
import ProgressIndicator from '../../../components/ui/ProgressIndicator';
import Icon from '../../../components/AppIcon';


const NotarizationProgress = ({ 
  isVisible, 
  currentStep, 
  isLoading, 
  onClose 
}) => {
  const notarizationSteps = [
    { 
      label: 'Capturing Screenshot', 
      description: 'Taking a full-page screenshot of the webpage' 
    },
    { 
      label: 'Uploading to IPFS', 
      description: 'Storing screenshot on decentralized network' 
    },
    { 
      label: 'Creating Transaction', 
      description: 'Preparing blockchain record with metadata' 
    },
    { 
      label: 'Confirming on Chain', 
      description: 'Finalizing notarization on Polygon blockchain' 
    }
  ];

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card border border-border rounded-lg shadow-elevated max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Notarization in Progress</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Creating permanent archive of your webpage
            </p>
          </div>
          {!isLoading && (
            <button
              onClick={onClose}
              className="flex items-center justify-center w-8 h-8 text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-smooth"
            >
              <Icon name="X" size={16} />
            </button>
          )}
        </div>

        {/* Progress Content */}
        <div className="p-6">
          <ProgressIndicator
            currentStep={currentStep}
            steps={notarizationSteps}
            isLoading={isLoading}
          />

          {/* Additional Info */}
          <div className="mt-6 p-4 bg-muted/30 rounded-md">
            <div className="flex items-start space-x-2">
              <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-foreground">What's happening?</p>
                <p className="text-xs text-muted-foreground mt-1">
                  We're creating a tamper-proof record of your webpage that includes a screenshot, 
                  metadata, and timestamp. This process ensures permanent, verifiable proof of the 
                  webpage's existence at this moment in time.
                </p>
              </div>
            </div>
          </div>

          {/* Warning */}
          {isLoading && (
            <div className="mt-4 p-3 bg-warning/5 border border-warning/20 rounded-md">
              <div className="flex items-start space-x-2">
                <Icon name="AlertTriangle" size={14} className="text-warning mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-xs text-warning font-medium">Please don't close this window</p>
                  <p className="text-xs text-warning/80 mt-1">
                    The notarization process is in progress. Closing this window may interrupt the transaction.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotarizationProgress;